module.exports = __webpack_public_path__ + "img/train_disabled2.4a58ae60.svg";